import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Flex, Spinner, VStack, Text } from '@chakra-ui/react'
import { SignIn } from '@clerk/clerk-react'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireOrganization?: boolean
}

export default function ProtectedRoute({ 
  children, 
  requireOrganization = false 
}: ProtectedRouteProps) {
  const { isSignedIn, loading, isAuthEnabled, currentOrg, isOrgLoading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
        <VStack spacing={4}>
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text color="text.secondary">Authenticating...</Text>
        </VStack>
      </Flex>
    )
  }

  if (!isAuthEnabled) {
    return <>{children}</>
  }

  if (!isSignedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requireOrganization && isOrgLoading) {
    return (
      <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
        <VStack spacing={4}>
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text color="text.secondary">Loading organization...</Text>
        </VStack>
      </Flex>
    )
  }

  if (requireOrganization && !currentOrg) {
    return <Navigate to="/organization/select" state={{ from: location }} replace />
  }

  return <>{children}</>
}
